import React, { useEffect, useState } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Card from "../Cards/Card";
import TextCard from "../Cards/TextCard";
import { BanknotesIcon, CurrencyDollarIcon, CalendarDaysIcon, ChartBarSquareIcon } from '@heroicons/react/24/outline';
import WebsiteTable from "../Website/WebsiteTable";
import { useAuth } from "../Auth/AuthContext";
import AdminSidebar from "../Side/AdminSidebar";
import RevenueChart from "../Dashboards/RevenueChart";
import axios from "axios";

const Overview = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';
    const { authState } = useAuth();
    const role = authState.roles;
    const admin = role === "Admin";

    // State to store revenue data
    const [revenues, setRevenues] = useState({
        todays: 0,
        yesterday: 0,
        lastsevendays: 0,
        thismonth: 0,
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });

        // Fetch revenue data when component mounts
        fetchCardRevenues();
    }, []);

    // Function to fetch revenue data
    const fetchCardRevenues = async () => {
        try {
            const userId = authState.user.id; // Assuming userId is stored in authState
            const response = await axios.get(`${baseUrl}analytics/GetCardsRevenue/${admin}&&${userId}`);
            
            if (response.data && response.data.isSuccess) {
                setRevenues(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching revenues:", error);
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {/* Sidebar */}
            {admin ? <AdminSidebar /> : <Sidebar />}

            {/* Main Content */}
            <div className="flex-1 bg-gray-100">
                <div className="flex-1 flex flex-col">
                    <Topbar />

                    {/* Main Content */}
                    <main className="pt-[100px] px-4">
                        {/* Show Loader while fetching data */}
            
                            <>
                                {/* Responsive Grid for Cards */}
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
                                    <Card title="Today's so far" value={`$${revenues.todays}`} color="text-orange-500" icon={BanknotesIcon} />
                                    <Card title="Yesterday" value={`$${revenues.yesterday}`} color="text-green-500" icon={CurrencyDollarIcon} />
                                    <Card title="Last seven days" value={`$${revenues.lastsevendays}`} color="text-blue-500" icon={CalendarDaysIcon} />
                                    <Card title="This month so far" value={`$${revenues.thismonth}`} color="text-yellow-500" icon={ChartBarSquareIcon} />
                                </div>

                                <RevenueChart />

                                {/* TextCard Section */}
                                <div className="mt-6">
                                    <TextCard />
                                </div>

                                {/* Transactions Table Section */}
                                <div className="mt-6">
                                    <WebsiteTable />
                                </div>
                            </>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Overview;
